import React from "react";
import Typography from "@pagepro-monorepo/ui/lib/components/styles/Typography";
import { GridBox } from "@pagepro-monorepo/ui/lib/components/styles/Grid";

import { NumberedListItemBoxProps } from "./types";
import * as Styled from "./styles";

const NumberedListItemBox: React.FC<NumberedListItemBoxProps> = ({
  number,
  title,
  description,
  color
}) => (
  <GridBox
    gridTemplateColumns={["", "", "1fr 10fr 8fr"]}
    gridGap={["1rem", "1rem", "1.875rem"]}
  >
    <Styled.Number {...{ color }}>{number}</Styled.Number>
    <Styled.Title>
      {typeof title === "string" ? (
        <Typography variant="heading3">{title}</Typography>
      ) : (
        title
      )}
    </Styled.Title>
    <Styled.Description>
      {typeof description === "string" ? (
        <Typography variant="body8">{description}</Typography>
      ) : (
        description
      )}
    </Styled.Description>
  </GridBox>
);

export default NumberedListItemBox;
